import React from 'react';
import BusinessMan from '../../../app/assets/images/businessman.png'

const ChooseUs = () => {
    return (
        <div className='min-h-[250px] bg-smart-city-bg bg-contain bg-center bg-no-repeat'>
            <div className='bg-black/60 backdrop-blur-sm min-h-[250px] flex flex-col md:flex-row px-4 sm:px-6 md:px-12 lg:px-20 xl:px-36 py-8 md:py-5 lg:py-0 items-center justify-center' >
                <div className="hidden md:flex justify-center md:justify-start w-full md:w-auto mb-6 md:mb-0">
                    <img 
                        src={BusinessMan} 
                        className='w-1/2 sm:w-1/3 md:w-[950px] max-h-[150px] md:max-h-[180px] lg:max-h-none object-contain' 
                        alt="Business Person"
                    />
                </div>
                <div className='md:pl-6 lg:pl-12 md:pr-6 lg:pr-20 xl:pr-40 text-center md:text-left'>
                    <div className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-3 md:mb-4'>Why choose us?</div>
                    <div className='text-sm sm:text-base md:text-lg lg:text-xl'>
                        We're not just iOS development experts, we're committed to
                        your success. With our flexible collaboration models, ongoing
                        support, and clear communication, we ensure your project
                        runs smoothly and exceeds your expectations. Your
                        vision is at the center of what we do, from the initial
                        consultation to the final update.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChooseUs
